export const ROUTE_PATH = '/clean/owner/listing' as const
